// extracted by mini-css-extract-plugin
export default {"history":"serviceAmountHistory_history__QRvlg","history_item":"serviceAmountHistory_history_item__I5FMn"};